import {
  InfoIconWrapper,
  InfoBadge
} from './alert-icon.styles';

const AlertIcon = ({ count = 0, Icon, onClick, label }) => {
    
    return (
      <InfoIconWrapper onClick={onClick} title={label}>
        <Icon />
        {count !== 0 &&
            <InfoBadge>{count}</InfoBadge>
        }
      </InfoIconWrapper>
    );
};

export default AlertIcon;